import React, { Component } from 'react';
import authorize from '../authorization/authorize';
import AccessDeniedBehavior from '../../services/enums/accessDeniedBehavior';
import Permissions from '../../services/enums/permissions';
import settings from './settings';
import PrivateRouteWrapper from '../router/privateRouteWrapper';
const AuthorizedSettings = authorize([Permissions.manageSystemSettings, Permissions.manageAuthenticationProviders], AccessDeniedBehavior.displayError)(settings);

export default class SettingsContainer extends Component {
    
    render() {
        return(
            <PrivateRouteWrapper>
                <AuthorizedSettings />
            </PrivateRouteWrapper>
        );
    }
}